import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container } from "@mui/material";

import { StyledTitle, StyledLink } from "./Register.styled";

import { PageTitle, Logo } from "@components/common";
import { RegisterForm } from "@components/form";
import { Box, Divider, Grid, Paper, Stack } from "@components/base";

const RegisterPage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box component="main" pt={6}>
      <PageTitle title={t("register.pageTitle")} />

      <Container maxWidth="sm">
        <Paper>
          <Stack direction="column" p={4} rowGap={3}>
            <Stack alignItems="center" direction="column" rowGap={2}>
              <Link to="/login">
                <Logo height={80} width={80} type="green0meter-with-csob" />
              </Link>

              <StyledTitle variant="h4">{t("register.title")}</StyledTitle>
            </Stack>

            <RegisterForm />
            <Divider />

            <Grid container>
              <Grid size={8}>
                <StyledLink to="/login">{t("register.havingAccount")}</StyledLink>
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default RegisterPage;
